module.exports = __webpack_public_path__ + "static/cell-a372c6d4eaa7b4e510dfaa3f9ba934af.png";